// eslint-disable-next-line no-unused-vars
import { get, isFalsy, set } from '@/utils'
import Widget from '@/utils/widgets/Widget'
// recursion!
const reqTest = inputList => {
  const output = {}
  inputList.forEach((listItem, listItemIndex) => {
    const { requiredFields, data, validators } = listItem
    // required fields
    if (requiredFields) {
      requiredFields.forEach(requiredField => {
        if (isFalsy(get(data, requiredField))) {
          if (output[listItemIndex] === undefined) output[listItemIndex] = {}
          output[listItemIndex][requiredField] = listItem.requiredMsg
        } else {
          // if nested
          if (Array.isArray(data[requiredField])) {
            // recursion!
            const childValue = reqTest(data[requiredField])
            if (!isFalsy(childValue)) {
              output[listItemIndex] = childValue
            }
          }
        }
      })
    }
    // validators messages
    if (validators) {
      for (const validatorField in validators) {
        const validatorList = validators[validatorField]

        const value = data[validatorField]
        // @TODO
        if (validatorList) {
          validatorList.forEach(validator => {
            // add message
            if (!Widget.validate(value, validator.name)) {
              if (output[listItemIndex] === undefined) output[listItemIndex] = {}
              if (!output[listItemIndex][validatorField]) {
                output[listItemIndex][validatorField] = validator.message
              }
            }
          })
        }
      }
    }
  })
  return output
}
/**
 * Used for list operations
 * this.$options.dynamicListName is required
 * this.fields[this.$options.dynamicListName] is required
 */
export default {
  data () {
    return {
      mixCopyListItemClipboard: {},
      mixValidationErrors: {}
    }
  },
  computed: {
    // creates an object of messages based on required fields and validators messages of each list item
    mixDynamicListValidationErrors () {
      return reqTest(this.fields[this.$options.dynamicListName])
    }
  },
  methods: {
    mixValidateField (value, validator = null) {
      if (validator) {
        if (Array.isArray(validator)) {
          return !validator.every(subValidator =>
            Widget.validate(value, subValidator.name)
          )
        }
        return !Widget.validate(value, validator)
      }
      if (value && Array.isArray(value)) return !value.length
      if (value && typeof value === 'object') return !Object.keys(value).length
      if (typeof value === 'boolean') return false
      return !value
    },
    mixValidateDynamicList (list, isListRequired = false) {
      this.mixValidationErrors = reqTest(this.fields[this.$options.dynamicListName])
      if (isListRequired && !list.length) return true
      return list.some(listItem => {
        return listItem.requiredFields.some(requiredField => {
          if (Array.isArray(listItem.data[requiredField])) {
            return this.mixValidateDynamicList(listItem.data[requiredField], true)
          } else {
            return this.mixValidateField(
              get(listItem.data, requiredField),
              listItem.validators[requiredField]
            )
          }
        })
      })
    },
    mixDeepCloneItem (item) {
      return Object.assign({}, JSON.parse(JSON.stringify(item)))
    },
    mixListItemsReassort (newList) {
      this.fields[this.$options.dynamicListName] = newList
    },
    mixCreateListItemHandler ({ title, ListItem }) {
      this.mixAddListItemHandler(new ListItem(title))
    },
    mixAddListItemHandler (newItem) {
      this.fields[this.$options.dynamicListName].push(newItem)
    },
    mixListItemChangeHandler ({ value, fieldName }, listItemIndex) {
      if (!fieldName) return
      set(
        this.fields[this.$options.dynamicListName][listItemIndex].data,
        fieldName,
        value
      )
    },
    mixListItemChangeItemHandler (
      { value, fieldName, itemIndex, itemField },
      listItemIndex
    ) {
      this.fields[this.$options.dynamicListName][listItemIndex].data[fieldName][
        itemIndex
      ].data[itemField] = value
    },
    mixListItemRemoveItemHandler ({ itemIndex, fieldName }, listItemIndex) {
      this.fields[this.$options.dynamicListName][listItemIndex].data[fieldName].splice(
        itemIndex,
        1
      )
    },
    mixListItemRemoveItem (itemIndex) {
      this.fields[this.$options.dynamicListName].splice(itemIndex, 1)
    },
    mixListItemDuplicateItem (item) {
      this.mixAddListItemHandler(this.mixDeepCloneItem(item))
    },
    mixListItemHideToggleItem (itemIndex) {
      this.fields[this.$options.dynamicListName][itemIndex].data.hidden =
        !this.fields[this.$options.dynamicListName][itemIndex].data.hidden
    },
    mixListItemCopyItem (item) {
      this.mixCopyListItemClipboard = this.mixDeepCloneItem(item)
    },
    mixListItemPasteItem (newItem, itemIndex) {
      this.fields[this.$options.dynamicListName].splice(itemIndex, 0, newItem)
    },
    mixListItemOptionHandler ({ value }, itemIndex, item) {
      // TODO: attention! hardcoded value in the cases
      switch (value) {
        case 'delete':
          this.mixListItemRemoveItem(itemIndex)
          break
        case 'duplicate':
          this.mixListItemDuplicateItem(item)
          break
        case 'hide':
          this.mixListItemHideToggleItem(itemIndex)
          break
        case 'copy':
          this.mixListItemCopyItem(item)
          break
        case 'paste':
          this.mixListItemPasteItem(this.mixCopyListItemClipboard, itemIndex)
          break
      }
    }
  },
  mounted () {
    if (
      this.$options.dynamicListName === undefined ||
      this.fields[this.$options.dynamicListName] === undefined
    ) {
      throw new Error('this.$options.dynamicListName is required field!')
    }
  }
}
